// Development: Parcel compiles Elm via @parcel/transformer-elm
export { Elm } from "./Main.elm";
